exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.modal-body label b {\n  color: #29363D;\n  font-size: 14px;\n  font-weight: 400; }\n\n.loading-icon {\n  text-align: center;\n  margin-top: 50px;\n  font-size: 50px;\n  color: #eeff00;\n  /* Màu của biểu tượng loading */ }\n\n.loader {\n  border: 16px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 16px solid #00fff2;\n  border-bottom: 16px solid #00fff2;\n  width: 80px;\n  height: 80px;\n  animation: spin 2s linear infinite; }\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/brand-report/brand-reports.component.scss
// module id = ../../../../../src/app/views/reports-module/brand-report/brand-reports.component.scss
// module chunks = main